export const actionNameConstants = {
  SKIP_STEP: 'Skip Steps',
  CHANGE_APPROVER: 'Change Approver',
  GENERATE_EXCEPTION: 'Generate Exception',
  REJECT: 'Reject',
  SEND_BACK_TO_EMPLOYEE: 'Send Back to Employee',
  SEND_EMAIL: 'Send Email',
  ADD_APPROVER:'Add Approvers'
}